<template>
  <section class="container">
    <full-page ref="fullpage" :options="options">
      <!-- Sección 1-->
      <div class="section" data-anchor="alq1" id="section1alq">
        <div class="fp-bg"></div>
        <!--  <v-img :src="image_srcAlqX" class="img-alqX" cover></v-img> -->
      </div>

      <!-- Sección 1b-->
      <div class="section" data-anchor="alq1b" id="section1balq">
        <div class="slide" id="slidealq">
          <div class="fp-bg"></div>
        </div>
      </div>

      <!-- Sección 2-->
      <div class="section" data-anchor="alq2" id="section2alq">
        <div class="fp-bg"></div>
        <v-container fluid>
          <v-row class="alq-texto1">
            <v-col cols="3">
              <img :src="image_srcpunto" class="punto" contain />
            </v-col>
            <v-col cols="9">
              <div>
                <p class="texto1">
                  Somos un Colectivo de arquitectura e interiorismo dinámico y
                  versátil que trabaja de manera colaborativa con diferentes
                  oficios, proponiendo un trabajo multidisciplinar enfocado en
                  solucionar los problemas de nuestros clientes.
                </p>
                <br />
                <p class="texto1">
                  Nuestro objetivo es generar identidad y atmósfera en los
                  espacios de nuestros encargos a través de un diseño integral
                  que se preocupa de plasmar un concepto claro en todas las
                  dimensiones: desde la configuración espacial, la gráfica, el
                  interiorismo y hasta el lenguaje comunicacional.
                </p>
                <br />
                <p class="texto1">
                  Para esto nos fusionamos dos alquimistas de la arquitectura
                  con un equipo de colaboradores, quienes se van integrando a la
                  creación en la medida justa y necesaria que requiere cada
                  proyecto, por lo que no son colaboradores fijos ni estáticos.
                </p>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </div>

      <!-- Sección 3-->
      <div class="section" data-anchor="alq3" id="section3alq">
        <div class="fp-bg"></div>
        <v-container fluid style="max-height: 8vh; position: relative;">
          <v-row class="titulos-row">
            <v-col cols="4">
              <p class="titulo1">LAS ALQUIMISTAS</p>
            </v-col>
            <v-col cols="8">
              <p class="bajada-texto">Dirección de proyectos</p>
            </v-col>
          </v-row>
        </v-container>
        <div class="linea-azul"></div>
        <v-img :src="image_src_alq" contain class="foto-alquimistas">
          <template v-slot:placeholder>
            <v-row class="fill-height ma-0" align="center" justify="center">
              <v-progress-circular
                indeterminate
                color="black"
              ></v-progress-circular>
            </v-row>
          </template>
        </v-img>

        <v-container fluid style="height: 80vh; position: relative;">
          <v-row>
            <v-col cols="3" xs="0"></v-col>

            <v-col cols="8" xs="12">
              <v-row
                class="row-isi"
                style="vertical-align: top; position: relative;"
              >
                <v-col
                  cols="7"
                  style="justify-content: flex-end; text-align: right;"
                >
                  <v-row style="justify-content: flex-end; text-align: right;">
                    <div class="texto-isi1">
                      Isidora Thomas
                      <br />Arquitecta Urbanista
                    </div>
                  </v-row>
                  <v-row
                    style="justify-content: flex-end; text-align: right; padding-top:5px;"
                  >
                    <div class="texto-isi2">Universidad de Chile</div>
                  </v-row>
                  <v-row style="justify-content: flex-end; text-align: right;">
                    <div class="texto-isi2">
                      Universidad Católica - Magister en Desarrollo Urbano
                    </div>
                  </v-row>
                  <v-row
                    style="justify-content: flex-end; text-align: right; padding-bottom:10px;"
                  >
                    <div class="texto-isi2">6 años de experiencia</div>
                  </v-row>
                  <v-row style="justify-content: flex-end; text-align: right;">
                    <div class="texto-isi3">Participación ciudadana</div>
                  </v-row>
                  <v-row style="justify-content: flex-end; text-align: right;">
                    <div class="texto-isi3">Tendencias de ciudades</div>
                  </v-row>
                  <v-row style="justify-content: flex-end; text-align: right;">
                    <div class="texto-isi3">Urbanismo táctico</div>
                  </v-row>
                </v-col>
                <v-col cols="4">
                  <v-row style="justify-content: flex-start; text-align: left;">
                    <v-img :src="image_src_isi" contain class="foto-isi">
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height ma-0"
                          align="center"
                          justify="center"
                        >
                          <v-progress-circular
                            indeterminate
                            color="black"
                          ></v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </v-row>
                </v-col>
              </v-row>

              <v-row class="row-dani">
                <v-col cols="4">
                  <v-row style="justify-content: flex-end; text-align: right;">
                    <v-img :src="image_src_dani" contain class="foto-dani">
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height ma-0"
                          align="center"
                          justify="center"
                        >
                          <v-progress-circular
                            indeterminate
                            color="black"
                          ></v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </v-row>
                </v-col>
                <v-col cols="8">
                  <v-row style="justify-content: flex-start; text-align: left;">
                    <div class="texto-dani1">
                      Daniela Oyarzún
                      <br />Arquitecta de Restauración e Interiorismo
                    </div>
                  </v-row>
                  <v-row
                    style="justify-content: flex-start; text-align: left; padding-top:5px;"
                  >
                    <div class="texto-dani2">Universidad de Chile</div>
                  </v-row>
                  <v-row style="justify-content: flex-start; text-align: left;">
                    <div class="texto-dani2">
                      Universidad Politécnica de Madrid - Postgrado en
                      Interiorismo
                    </div>
                  </v-row>
                  <v-row
                    style="justify-content: flex-start; text-align: left; padding-bottom:10px;"
                  >
                    <div class="texto-dani2">6 años de experiencia</div>
                  </v-row>
                  <v-row style="justify-content: flex-start; text-align: left;">
                    <div class="texto-dani3">
                      Diseño de espacios itinerantes
                    </div>
                  </v-row>
                  <v-row style="justify-content: flex-start; text-align: left;">
                    <div class="texto-dani3">
                      Remodelación de proyectos habitacionales y comerciales
                    </div>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </div>

      <!-- Sección 4-->
      <div class="section" data-anchor="alq4" id="section4alq">
        <div class="fp-bg"></div>
        <v-container fluid style="max-height: 8vh; position: relative;">
          <v-row class="titulos-row">
            <v-col cols="4">
              <p class="titulo2">LOS COLABORADORES</p>
            </v-col>
            <v-col cols="8">
              <p class="bajada-texto2">Producción - Gráfica - Especialidades</p>
            </v-col>
          </v-row>
        </v-container>
        <div class="linea-azul"></div>

        <v-container fluid style="height: 80vh; position: relative;">
          <v-row>
            <v-col class="col-colab" cols="4" xs="3">
              <div class="texto-col-colab">
                <b>Especialistas y oficios</b>
              </div>
              <div class="texto-col-colab-mini">
                ceramistas, soldadores, iluminadores, paisajistas...
              </div>
              <br />
              <br />
              <br />
              <div class="texto-col-colab" style="padding-right: 28px;">
                <b>Artistas emergentes</b>
              </div>
              <div class="texto-col-colab">
                <b>Fotógrafos</b>
              </div>
              <br />
              <br />
              <div class="texto-col-colab">
                <b>Ilustradores</b>
              </div>
              <div class="texto-col-colab">
                <b>Diseño Gráfico</b>
              </div>
              <br />
              <br />
              <div class="texto-col-colab">
                <b>Chefs</b>
              </div>
              <div class="texto-col-colab">
                <b>propuesta</b>
              </div>
              <div class="texto-col-colab">
                <b>gastronómica</b>
              </div>
            </v-col>

            <v-col cols="8" xs="9" class="alq-colab">
              <div class="circle">
                <div class="texto2">
                  <p>
                    El
                    <b>trabajo colaborativo</b> es lo que nos mueve y creemos
                    que nos potencia como colectivo. Existe la apertura de
                    entender que <b>toda disciplina aporta un ángulo único</b> y
                    clave para construir el otro, generando propuestas más
                    complejas. Para esto hacemos
                    <b>alianzas temporales</b> entre diferentes actores,
                    escogidos con pinza para cada proyecto y en conjunto creamos
                    un <b>concepto fuerte</b> para plasmar en el proyecto, asi
                    como su diseño materializado y su ejecución.
                  </p>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </div>

      <!-- Sección 5-->
      <div class="section" data-anchor="alq5" id="section5alq">
        <v-container fluid>
          <v-row>
            <v-col
              style="background-color: #f0f0f0; padding-right:20px;position:relative; z-index: -1; bottom:40vh; height: 70vh; padding-top: 0; margin-top:0;"
              cols="4"
            ></v-col>
          </v-row>
        </v-container>
        <div class="fp-bg"></div>

        <br />
        <div class="qhacemos-container">
          <div class="tit-blanco">
            <p class="qhacemos">¿QUÉ HACEMOS?</p>
          </div>
          <p class="qhacemos-italic">LUGARES CON IDENTIDAD</p>
        </div>

        <div class="servicios-container">
          <v-container fluid>
            <v-row>
              <v-col cols="2" xs="4">
                <div class="nuestros-servicios">
                  <v-select
                    :items="items"
                    v-model="defaultSelected"
                    background-color="rgba(0,0,0,0)"
                    color="#000000"
                    dark
                    full-width
                    outlined
                  ></v-select>
                </div>
              </v-col>
              <v-col cols="10" xs="8">
                <span v-touch:swipe="swipeHandlerServicios">
                  <ul class="servicios" :style="yListaAlq" id="lista1">
                    <li
                      id="li-2"
                      v-for="servicio in servicios"
                      :key="servicio.numero"
                    >
                      <div
                        class="titulo-servicio"
                        @click="selectServicio(servicio)"
                        v-bind:style="[
                          servicio.numero == servicioSeleccionado
                            ? { opacity: '1' }
                            : { opacity: '0.4' },
                        ]"
                      >
                        <div
                          class="nServicio"
                          v-bind:style="[
                            servicio.numero == servicioSeleccionado
                              ? {
                                  'border-bottom': '3px solid white',
                                  opacity: '1',
                                  transform: 'translateX(0px)',
                                }
                              : {
                                  'border-bottom': '0px solid white',
                                  opacity: '0',
                                  transform: 'translateX(-90px)',
                                },
                          ]"
                        >
                          {{ servicio.numeroString }}
                        </div>
                        <div class="titulo-servicio-interno">
                          {{ servicio.titulo }}
                        </div>
                      </div>
                      <div
                        class="resumenServicio"
                        v-bind:style="[
                          servicio.numero == servicioSeleccionado
                            ? { opacity: '1' }
                            : { opacity: '0.3' },
                        ]"
                      >
                        {{ servicio.resumen }}
                      </div>
                    </li>
                  </ul>
                </span>
                <div class="nTotalServicios">03</div>
              </v-col>
            </v-row>
          </v-container>
        </div>
      </div>
    </full-page>
  </section>
</template>

<script>
import store from "../store";

export default {
  data() {
    return {
      servicios: [
        {
          numero: 1,
          numeroString: "01",
          isActive: true,
          titulo: "DISEÑO: Identidad y desarrollo de espacios integrales",
          resumen: "Concepto-Interiorismo-Arte-Gráfica",
        },
        {
          numero: 2,
          numeroString: "02",
          isActive: true,
          titulo: "MOMENTOS: Eventos e instralaciones",
          resumen: "Diseño de atmósfera",
        },
        {
          numero: 3,
          numeroString: "03",
          isActive: true,
          titulo: "CIUDAD: Urbanismo táctico",
          resumen: "Activación de espacios públicos",
        },
      ],
      defaultSelected: "Servicios",
      items: ["Servicios"],
      posicionListaAlq: 0,
      servicioSeleccionado: 1,
      image_srcpunto: require("../assets/punto.png"),
      image_srcalqfooter: require("../assets/ALQ-FINAL.png"),
      image_srcAlq1: require("../assets/Imagen-inicio.jpg"),
      image_srcAlqX: require("../assets/Imagen-inicio2.jpg"),
      image_src3: require("../assets/alquimistas-fotos.jpg"),
      image_src4: require("../assets/MUJER.png"),
      image_src_alq: require("../assets/FOTO-ALQUIMISTAS.png"),
      image_src_dani: require("../assets/FOTO-DANI.png"),
      image_src_isi: require("../assets/foto-isi.png"),
      image_srcTruco: require("../assets/Imagen-inicio2.jpg"),
      options: {
        licenseKey: "265864DA-1DE54052-9BEBB977-EF50CFB8",
        autoScrolling: true,
        parallax: true,
        parallaxKey: [
          "Y29sZWN0aXZvYWxxdWltaWEuY2xfYmxNY0dGeVlXeHNZWGc9OTJR",
          "Y29sZWN0aXZvLWFscXVpbWlhLndlYi5hcHBfdjhXY0dGeVlXeHNZWGc9QVEw",
          "Y29sZWN0aXZvLWFscXVpbWlhLndlYi5hcHBfNjI0Y0dGeVlXeHNZWGc9WVlP",
        ],
        // parallaxKey: '7CD7B03B-68104BF5-88FFE8B4-2585F4CC',
        // activation-key for domain colectivoalquimia.cl: Y29sZWN0aXZvYWxxdWltaWEuY2xfcmg0Y0dGeVlXeHNZWGc9bHhi
        fitToSection: true,
        anchors: ["alq1", "alq1b", "alq2", "alq3", "alq4", "alq5"],
        bigSectionsDestination: "top",
        parallaxOptions: {
          type: "cover",
          percentage: 99,
          property: "translate",
        },
        scrollingSpeed: "700",
        onLeave: function(origin, destination, direction) {
          if (origin.index == 0) {
            store.commit("esconder");
          } else if (origin.index == 1 && direction == "up") {
            store.commit("mostrar");
          }
        },
      },
    };
  },
  metaInfo: {
    title: "Colectivo Alquimia",
    titleTemplate: "%s | Alquimistas & Colaboradores",
  },
  computed: {
    yListaAlq() {
      return `transform: translateY(${this.posicionListaAlq}%)`;
    },
  },
  methods: {
    isOnTop() {
      if (this.$refs.fullpage.api.getActiveSection().anchor == "alq1") {
        return true;
      } else {
        return false;
      }
    },
    getSection() {
      return this.$refs.fullpage.api.getActiveSection().anchor;
    },
    getSectionIndex() {
      return this.$refs.fullpage.api.getActiveSection().index;
    },
    selectServicio(servicio) {
      //  this.$router.push({path: ruta});
      this.servicioSeleccionado = servicio.numero;
      let n = this.servicioSeleccionado - 1;
      this.posicionListaAlq = n * -33.3;
      // this.$refs.fullpage.api.moveTo(4, n);
    },
    swipeHandlerServicios(direction) {
      if (direction == "bottom") {
        let m = this.servicioSeleccionado - 1;
        if (this.servicioSeleccionado == 2) {
          this.posicionListaAlq = m * -33.3;
          this.servicioSeleccionado = 1;
        } else if (this.servicioSeleccionado == 3) {
          this.posicionListaAlq = m * -33.3;
          this.servicioSeleccionado = 2;
        }
      } else {
        let m = this.servicioSeleccionado - 1;
        if (this.servicioSeleccionado == 1) {
          this.posicionListaAlq = m * -33.3;
          this.servicioSeleccionado = 2;
        } else if (this.servicioSeleccionado == 2) {
          this.posicionListaAlq = m * -33.3;
          this.servicioSeleccionado = 3;
        }
      }
    },
  },
  mounted() {
    window.addEventListener("wheel", this.onWheel, true);
    this.$refs.fullpage.api.moveTo(0);
    store.commit("mostrar");
  },
};
</script>

<style>
@import "/assets/styles/main.css";

.fp-bg {
  background-color: rgba(0, 0, 0, 0) !important;
  background-size: cover;
  transform: translate3d(0, 0, 0);
  -webkit-backface-visibility: hidden; /* Chrome, Safari, Opera */
  backface-visibility: hidden;
}
.container {
  padding: 0px;
  margin: 0px;
  transition: all 0.45s ease-in-out;
  transition: all 0.45s cubic-bezier(0.55, 0, 0.1, 1);
}
#lista1 {
  list-style-type: none;
}
.v-application ul,
.v-application ol {
  padding-left: 0px !important;
}
.backgroundImagen {
  background-image: url("../assets/Imagen-inicio.jpg");
  background-size: cover;
  height: 100%; /* You must set a specified height */
  width: 100%;
  top: 0%;
  left: 0%;
  z-index: 1;
}
.backgroundImagenb {
  background-image: url("../assets/COLORES-ALQUIMISTAS.jpg");
  height: 100vh; /* You must set a specified height */
}
.backgroundImagenc {
  background-image: url("../assets/alquimistas-fotos.jpg");
  background-position: center; /* Center the image */
  background-repeat: no-repeat; /* Do not repeat the image */
  background-size: contain; /* Resize the background image to cover the entire container */
  -webkit-background-size: contain;
  -moz-background-size: contain;
  -o-background-size: contain;
  align-content: center;
  height: 90vh; /* You must set a specified height */
  width: 90vw;
  z-index: 1;
}
.section {
  background-color: rgba(0, 0, 0, 0);
  min-width: 100vw;
  min-height: 100vh;
  z-index: -1;
}
.slide {
  background-color: rgba(0, 0, 0, 0);
  height: 100vh;
}

#section4alq .fp-bg {
  background-size: cover;
  background-position: center 80%;
}
.mona {
  position: absolute;
}

.v-list-item .v-list-item__title,
.v-list-item .v-list-item__subtitle {
  color: black !important;
  width: 10vw;
  max-width: 15vw !important;
}
.v-list-item:active .v-list-item__subtitle:active {
  color: black !important;
  width: 10vw;
  max-width: 15vw !important;
}

@media (min-width: 960px) {
  #slidealq {
    position: fixed !important;
    background-color: rgba(0, 0, 0, 0);
  }
  .img-alqX {
    position: fixed;
    top: 0;
    left: 0;
    height: 0vh;
    width: 0vw;
    z-index: 999;
  }
  .img-alqTruco {
    position: fixed;
    bottom: 0 !important;
    left: 0;
    height: 100vh;
    width: 100vw;
    z-index: 999;
  }
  .servicios-container {
    position: absolute;
    bottom: 5vh;
    left: 5vw;
  }
  .servicios {
    position: absolute;
    bottom: 0vh;
    line-height: 1;
    max-width: 60vw;
    left: 25vw;
    z-index: 99;
    transition-duration: 625ms;
    transition: opacity 0.5s, transform 0.5s;
  }
  #li-2 {
    white-space: normal;
    width: 10vw;
    min-height: 14vh;
  }
  .resumenServicio {
    position: relative;
    color: white;
    font-family: "Source-light";
    font-size: calc(8.5px + 1.0125vw);
    min-width: 50vw;
    max-width: 60vw;
    min-height: 6vh;
    margin-bottom: 3vh;
    margin-top: 0vh;
    left: 8vw;
    top: 0px;
    padding-top: 1vh;
    transition-duration: 625ms;
    transition: opacity 0.5s, transform 0.5s;
  }
  .nServicio {
    position: absolute;
    font-size: calc(16.5px + 2.8125vw);
    font-family: "Source";
    color: white;
    width: 120px;
    right: 50vw;
    top: -6vh;
    transition: opacity 0.5s, transform 0.5s;
  }
  .selectServicio {
    position: relative;
  }
  .titulo-servicio {
    position: relative;
    width: 50vw;
    min-height: 5vh;
    max-height: 30%;
    top: 0px;
    text-align: left;
    margin-top: 0vh;
    margin-bottom: 0vh;
    margin-left: 8vw;
    font-size: calc(8.5px + 1.48125vw);
    font-family: "Source-bold";
    color: white;
    text-decoration: none;
    transition-duration: 625ms;
    transition: opacity 0.5s, transform 0.5s;
    z-index: 99;
    cursor: pointer;
  }
  .titulo-servicio:hover {
    opacity: 0.9 !important;
  }
  .titulo-servicio-interno {
    content: "";
    max-width: 50vw;
    min-height: 5vh;
    position: relative;
    white-space: normal;
  }
  .punto {
    position: absolute;
    top: 30vh;
    left: 20vw;
    height: 10%;
    z-index: 11;
  }
  #section1alq .fp-bg {
    position: fixed !important;
    bottom: 0;
    background-image: url("../assets/Imagen-inicio2.jpg");
    background-size: cover;
    background-position: center 90%;
    margin-bottom: 100vh;
    height: 100vh !important;
  }
  #section1balq .fp-bg {
    position: fixed !important;
    top: 0;
    /*background-image: url("../assets/Imagen-inicio2.jpg");*/
    background-size: cover;
    height: 100vh !important;
    margin-top: 100vh;
  }
  #section2alq .fp-bg {
    margin-top: 0vh;
    background-color: rgba(0, 0, 0, 0);
    background-size: cover;
    background-position: center 80%;
  }
  #section3alq .fp-bg {
    margin-top: 0vh;
    background-color: rgba(0, 0, 0, 0);
    background-size: cover;
    background-position: center 80%;
  }
  .seccion1a {
    padding-top: 100vh;
  }
  .alq-texto1 {
    position: relative;
    margin-top: 15vh;
    margin-bottom: 15vh;
  }
  .titulos-row {
    margin-top: 0vh;
  }
  .primera-imagen {
    position: relative;
    object-fit: contain;
    width: 100vw;
    z-index: 1;
  }
  .texto1 {
    font-size: calc(8px + 1vw);
    color: #372b5d;
    padding-left: 10px;
    padding-right: 5vw;
  }
  .texto2 {
    font-size: calc(5.5px + 1.01875vw);
    color: #372b5d;
    line-height: 1.5;
  }
  .linea-azul {
    content: "";
    position: relative;
    width: 100vw;
    height: 20px;
    background: #372b5d;
    z-index: 10;
  }
  .titulo1 {
    font-size: calc(12.5px + 1.41875vw);
    line-height: 1;
    bottom: 0px;
    justify-content: flex-end;
    font-family: "Source-bold";
    color: #372b5d;
    text-align: right;
    margin-bottom: 0px !important;
  }
  .titulo2 {
    font-size: calc(12.5px + 1.41875vw);
    line-height: 1;
    bottom: 0px;
    justify-content: flex-end;
    font-family: "Source-bold";
    color: #372b5d;
    text-align: right;
    margin-bottom: 0px !important;
  }
  .bajada2 {
    top: 20px;
    display: flex;
    padding-bottom: 0px;
    justify-content: center;
    align-content: center;
    bottom: 0px;
    position: relative;
    align-items: bottom;
  }
  .bajada-texto {
    line-height: 1;
    margin-bottom: 0px !important;
    justify-content: center;
    font-size: calc(18.5px + 1.01875vw);
    font-family: "Source-bold";
    color: #372b5d;
    text-align: center;
  }
  .bajada-texto2 {
    line-height: 1;
    margin-bottom: 0px !important;
    justify-content: center;
    font-size: calc(14.5px + 1.21875vw);
    font-family: "Source-bold";
    color: #372b5d;
    text-align: center;
  }
  .somos-imagen {
    height: 100vh;
    width: 100vw;
    padding-top: 10vh;
  }
  .iconalq {
    position: relative;
    color: #372b5d;
    padding-left: 25px;
    padding-right: 25px;
    bottom: 0px;
    align-items: top;
  }
  .texto-col-colab {
    position: relative;
    top: 6vh;
    display: inline;
    text-align: center;
    font-size: calc(6.5px + 1.01875vw);
  }
  .texto-col-colab-mini {
    position: relative;
    top: 6vh;
    display: inline;
    text-align: center;
    font-size: calc(6.5px + 1.01875vw);
  }
  .texto-col-colab:after {
    content: "\a";
    white-space: pre;
  }
  .col-colab {
    margin-right: auto;
    margin-left: auto;
    padding-left: 50px;
    height: 100vh;
    background-color: #f0f0f0;
    padding-right: 50px;
    text-align: center;
  }
  .alq-colab {
    color: #fceae0;
    padding-left: 10vw;
    padding-right: 10vw;
    padding-top: 2vh;
  }
  .circle {
    position: absolute;
    padding-top: 15vh;
    padding-bottom: 5vh;
    padding-left: 7vw;
    padding-right: 5vw;
    background: #fceae0;
    width: 800px;
    height: 800px;
    -moz-border-radius: 400px;
    -webkit-border-radius: 400px;
    border-radius: 400px;
  }
  .alq-bck-final {
    /*background-image: url("../assets/COLOR-FINAL.png");*/
    position: fixed;
    top: 0px;
    z-index: 10;
  }
  .tit-blanco {
    transition: 325ms cubic-bezier(0.445, 0.05, 0.015, 1);
    font-size: calc(18.5px + 1.1875vw);
    padding-right: 10vw;
  }
  .tit-blancoa {
    transition: 325ms cubic-bezier(0.445, 0.05, 0.015, 1);
    font-size: calc(18.5px + 1.1875vw);
    padding-right: 10vw;
  }
  .tit-blanco::before {
    content: "";
    cursor: default;
    position: absolute;
    right: 100%;
    top: 45%;
    width: 3.5em;
    height: 3px;
    background: black;
  }
  .qhacemos {
    font-family: "Source-bold";
    color: black;
    font-size: calc(8.5px + 1.01875vw);
  }
  .qhacemos-italic {
    color: black;
    font-style: italic;
    font-size: calc(6.5px + 1.01875vw);
  }
  .qhacemos-container {
    position: absolute;
    top: 5vh;
    right: 25vw;
    font-size: 36px;
    padding-top: 5vh;
    line-height: 1;
    font-weight: 300;
  }
  .nuestros-servicios {
    position: absolute;
    bottom: 25vh;
    text-align: center;
    justify-content: center;
    font-size: 20px;
    margin-left: 6vw;
    font-size: calc(6.5px + 1.01875vw);
    font-family: "Source";
    margin-right: 2vw;
    width: 14vw;
    max-width: 15vw;
    color: white;
    /*border-bottom: 2px solid white;
    border-top: 2px solid white;*/
    padding-top: 3vh;
  }
  .alq-footer {
    position: absolute;
    top: 0vh;

    height: 100vh;
    z-index: 30;
  }
  .numero-servicio {
    font-size: 62px;
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .texto-servicios {
    font-size: 32px;
    padding-right: 10%;
    padding-top: 60px;
    font-family: "Source-bold";
    line-height: 1;
    transition: 325ms cubic-bezier(0.445, 0.05, 0.015, 1);
  }
  .texto-servicios:hover {
    opacity: 0.8;
  }
  .texto-servicios2 {
    font-size: 32px;
    padding-right: 5%;
    padding-top: 30px;
    font-family: "Source-bold";
    line-height: 1;
    transition: 325ms cubic-bezier(0.445, 0.05, 0.015, 1);
  }
  .texto-servicios2:hover {
    opacity: 0.8;
  }
  .texto-servicios3 {
    font-size: 32px;
    padding-right: 10%;
    padding-top: 60px;
    font-family: "Source-bold";
    line-height: 1;
    transition: 325ms cubic-bezier(0.445, 0.05, 0.015, 1);
  }
  .texto-servicios3:hover {
    opacity: 0.8;
  }
  .bajadilla-servicios {
    font-size: 25px;
    font-family: "Source";
    opacity: 0.8;
  }
  .bajadilla-servicios2 {
    font-size: 25px;
    font-family: "Source";
    opacity: 0.8;
  }
  .bajadilla-servicios3 {
    font-size: 25px;
    font-family: "Source";
    opacity: 0.8;
  }
  .mona {
    position: absolute;
    bottom: 98vh;
    height: 6%;
    z-index: 99;
  }
  .foto-alquimistas {
    position: absolute;
    width: 20%;
    left: 8vw;
    top: 25vh;
  }
  .nTotalServicios {
    position: absolute;
    bottom: 5vh;
    left: 25vw;
    font-size: calc(16.5px + 2.8125vw);
    font-family: "Source";
    display: inline-block;
    padding-bottom: 0px;
    margin-bottom: 0px;
    color: white;
    transition: opacity 0.5s, transform 0.5s;
    z-index: 99;
    opacity: 0.3;
  }
  .row-dani {
    position: relative;
    vertical-align: top;
    top: 2vh;
  }
  .foto-dani {
    max-width: 15vw;
  }
  .texto-dani1 {
    font-size: calc(10.5px + 1.41875vw);
    padding-left: 4vw;
    line-height: 1;
    padding-right: 15vw;
    padding-top: 10px;
    font-style: italic;
    font-weight: 800;
  }
  .texto-dani2 {
    font-size: calc(4.5px + 0.81875vw);
    padding-left: 4vw;
    padding-right: 10vw;
    font-weight: 300;
    font-style: italic;
    line-height: 1;
  }
  .texto-dani3 {
    line-height: 1.2;
    font-size: calc(4.5px + 1.01875vw);
    padding-left: 4vw;
    padding-right: 20vw;
  }
  .foto-isi {
    max-width: 15vw;
    left: 6vw;
  }
  .texto-isi1 {
    position: relative;
    padding-top: 2vh;
    line-height: 1;
    font-weight: 800;
    padding-left: 20vw;
    right: -2vw;
    font-size: calc(10.5px + 1.41875vw);
    font-style: italic;
  }
  .texto-isi2 {
    position: relative;
    font-size: calc(4.5px + 0.81875vw);
    right: -2vw;
    padding-left: 10vw;
    line-height: 1;
    font-weight: 300;
    font-style: italic;
  }
  .texto-isi3 {
    position: relative;
    right: -2vw;
    font-size: calc(4.5px + 1.01875vw);
    line-height: 1.2;
  }
  .espacio {
    padding-top: 8vh;
  }
}
@media (max-width: 960px) {
  #slidealq {
    background-color: rgba(0, 0, 0, 0);
  }
  .img-alqX {
    position: fixed !important;
    top: 0;
    right: 0;
    padding-left: 320vw;
    height: 100vh;
    width: 100vw;
    z-index: 999;
  }
  .img-alqTruco {
    position: fixed !important;
    top: 0 !important;
    left: 0;
    height: 100vh;
    z-index: 999;
  }
  .servicios-container {
    position: absolute;
    bottom: 15vh;
    right: 60vw;
    z-index: 999;
  }
  .servicios {
    position: absolute;
    bottom: 0vh;
    line-height: 1.2;
    max-width: 50vw;
    left: 0vw;
    z-index: 99;
    transition-duration: 625ms;
    transition: opacity 0.5s, transform 0.5s;
  }
  #li-2 {
    white-space: normal;
    max-width: 50vw;
  }
  .resumenServicio {
    position: relative;
    color: white;
    font-family: "Source-light";
    font-size: calc(10.5px + 1.0125vw);
    max-width: 60vw;
    left: 8vw;
    min-height: 2vh;
    top: 0px;
    padding-top: 0vh;
    margin-top: 0vh;
    margin-bottom: 3vh;
    transition-duration: 625ms;
    transition: opacity 0.5s, transform 0.5s;
  }
  .nServicio {
    position: absolute;
    font-size: calc(14.5px + 2.8125vw);
    font-family: "Source";
    color: white;
    width: 50px;
    right: 45vw;
    top: -2vh;
    transition: opacity 0.5s, transform 0.5s;
    transform: translateX(200px);
  }
  .selectServicio {
    position: relative;
  }
  .titulo-servicio {
    position: relative;
    max-width: 50vw;
    top: 0px;
    text-align: left;
    margin-left: 8vw;
    min-height: 5vh;
    font-size: calc(10.5px + 1.68125vw);
    font-family: "Source-bold";
    color: white;
    text-decoration: none;
    transition-duration: 625ms;
    transition: opacity 0.5s, transform 0.5s;
    z-index: 10;
    cursor: pointer;
  }
  .titulo-servicio:hover {
    opacity: 0.9 !important;
  }
  .titulo-servicio-interno {
    content: "";
    width: 50vw;
    position: relative;
    white-space: normal;
  }
  .fondo-gris {
    content: "";
    position: fixed;
    background: #929294;
    background-color: #929294;
    background-position: bottom;
    background-size: cover;
    height: 50vh;
    width: 100vw;
    padding-bottom: 0px;
    margin-bottom: 0px;
    bottom: 0px;
    z-index: 1;
  }
  .punto {
    position: absolute;
    top: 40vh;
    left: 10vw;
    height: 4%;
    z-index: 99;
  }
  #section1alq .fp-bg {
    background-color: #feebdd !important;
    position: absolute !important;
    top: 0;
    /* background-image: url("../assets/Imagen-inicio2.jpg"); */
    background-size: cover;
    margin-bottom: 0vh;
    height: 100vh !important;
    background-position: right 80%;
    z-index: 9;
  }
  #section1balq .fp-bg {
    /*background-color: #feebdd !important;*/
    background-color: rgba(0, 0, 0, 0);
    position: absolute !important;
    top: 0vh;
    background-image: url("../assets/Imagen-inicio2.jpg");
    background-size: cover;
    background-position: right 50%;
    height: 100vh !important;
    margin-top: 0vh;
    z-index: 1;
  }
  #section2alq .fp-bg {
    background-color: rgba(0, 0, 0, 0);
    background-size: cover;
    background-position: center 80%;
  }
  #section3alq .fp-bg {
    background-color: rgba(0, 0, 0, 0);
    background-size: cover;
    background-position: center 80%;
  }
  .primera-imagen {
    position: relative;
    height: 100vh;
    z-index: 1;
    object-fit: cover;
  }
  .linea-azul {
    content: "";
    position: relative;
    width: 100vw;
    height: 20px;
    background: #372b5d;
    z-index: 10;
  }
  .alq-texto1 {
    position: relative;
  }
  .titulos-row {
    margin-top: 10vh;
  }
  .titulo1 {
    position: absolute;
    bottom: 0px;
    max-width: 33vw;
    font-size: calc(12.5px + 1.01875vw);
    line-height: 1;
    margin-left: 2vw;
    justify-content: flex-end;
    font-family: "Source-bold";
    color: #372b5d;
    text-align: right;
    margin-bottom: 1px !important;
  }
  .titulo2 {
    position: absolute;
    font-size: calc(10.5px + 1.01875vw);
    bottom: 0px;
    max-width: 33vw;
    line-height: 1;
    margin-left: 0vw;
    justify-content: flex-end;
    font-family: "Source-bold";
    color: #372b5d;
    text-align: right;
    margin-bottom: 1px !important;
  }
  .texto1 {
    font-size: calc(7.5px + 1vw);
    color: #372b5d;
    padding-right: 5vw;
  }
  .bajada-texto {
    position: absolute;
    bottom: 0px;
    margin-bottom: 1px !important;
    margin-left: 15vw;
    line-height: 1;
    justify-content: center;
    font-size: calc(10.5px + 1.01875vw);
    font-family: "Source-bold";
    color: #372b5d;
    text-align: center;
  }
  .bajada-texto2 {
    position: absolute;
    bottom: 0px;
    margin-bottom: 1px !important;
    margin-left: 2vw;
    line-height: 1;
    justify-content: center;
    font-size: calc(10.5px + 1.01875vw);
    font-family: "Source-bold";
    color: #372b5d;
    text-align: center;
  }
  .iconalq {
    color: #372b5d;
    top: 0px;
    height: 1vh;
    align-items: top !important;
  }
  .texto-col-colab {
    position: relative;
    top: 1vh;
    margin-right: 3vw;
    min-width: 25vw;
    max-width: 25vw;
    line-height: 1 !important;
    text-align: center;
    font-family: "Source-bold";
    font-size: calc(5.5px + 1.21875vw);
  }
  .texto-col-colab-mini {
    position: relative;
    top: 1vh;
    display: inline;
    text-align: center;
    font-family: "Source-bold";
    font-size: calc(5px + 1.01875vw);
    font-family: "Source";
    line-height: 0.8;
  }
  .texto-col-colab:after {
    content: "\a";
    white-space: pre;
  }
  .col-colab {
    text-align: center;
    justify-content: center;
    height: 100vh;
    width: 30vw;
    padding-right: 5px;
    padding-left: 15px;
    max-width: 35vw;
    background-color: #f0f0f0;
    padding-top: 5vh;
    line-height: 1 !important;
  }
  .alq-bck-final {
    background-image: url("../assets/COLOR-FINAL.png");
    height: 70vh;
  }
  .tit-blanco {
    transition: 325ms cubic-bezier(0.445, 0.05, 0.015, 1);
    font-size: calc(8.5px + 1.21875vw);
    color: black;
  }
  .tit-blancoa {
    transition: 325ms cubic-bezier(0.445, 0.05, 0.015, 1);
    font-size: calc(8.5px + 1.21875vw);
    color: black;
  }
  .tit-blanco::before {
    content: "";
    cursor: default;
    position: absolute;
    right: 100%;
    top: 40%;
    width: 3.5em;
    height: 2px;
    background: black;
  }
  .qhacemos {
    font-family: "Source-bold";
    color: black;
    font-size: calc(8.5px + 2.5875vw);
  }
  .qhacemos-italic {
    color: black;
    font-style: italic;
    font-size: calc(8.5px + 2.5875vw);
  }
  .qhacemos-container {
    position: absolute;
    top: 4vh;
    right: 5vw;
    font-size: 36px;
    padding-top: 5vh;
    line-height: 1;
    font-weight: 300;
    z-index: 999;
  }
  .nuestros-servicios {
    position: absolute;
    bottom: 15vh;
    right: 15vw;
    text-align: center;
    justify-content: center;
    font-size: 20px;
    padding-left: 2vw;
    font-size: calc(4.5px + 1.41875vw);
    font-family: "Source";
    width: 22vw;
    color: white;
    /*border-bottom: 2px solid white;
    border-top: 2px solid white;*/
    padding-top: 2vh;
    padding-bottom: 2vh;
    z-index: 30;
  }
  .v-list-item .v-list-item__title,
  .v-list-item .v-list-item__subtitle {
    color: black !important;
  }
  .v-text-field--filled > .v-input__control > .v-input__slot,
  .v-text-field--full-width > .v-input__control > .v-input__slot,
  .v-text-field--outlined > .v-input__control > .v-input__slot {
    width: 33vw;
    max-width: 35vw;
    height: 1vh;
  }
  .nTotalServicios {
    position: absolute;
    bottom: 5vh;
    right: -15vw;
    font-size: calc(15.5px + 2.8125vw);
    font-family: "Source";
    display: inline-block;
    width: 120px;
    padding-bottom: 0px;
    margin-bottom: 0px;
    color: white;
    transition: opacity 0.5s, transform 0.5s;
    z-index: 99;
    opacity: 0.4;
  }
  .alq-footer {
    position: absolute;
    top: 20vh;
  }
  .numero-servicio {
    font-size: 14px;
    padding-top: 10px;
  }
  .texto-servicios {
    font-size: 12px;
    padding-right: 30%;
    padding-top: 10px;
    font-family: "Source-bold";
    line-height: 1;
    transition: 325ms cubic-bezier(0.445, 0.05, 0.015, 1);
  }
  .texto-servicios:hover {
    opacity: 0.8;
  }
  .texto-servicios2 {
    font-size: 12px;
    padding-right: 10%;
    padding-top: 20px;
    font-family: "Source-bold";
    line-height: 1;
    transition: 325ms cubic-bezier(0.445, 0.05, 0.015, 1);
  }
  .texto-servicios2:hover {
    opacity: 0.8;
  }
  .texto-servicios3 {
    font-size: 12px;
    padding-right: 10%;
    padding-top: 20px;
    font-family: "Source-bold";
    line-height: 1;
    transition: 325ms cubic-bezier(0.445, 0.05, 0.015, 1);
  }
  .texto-servicios3:hover {
    opacity: 0.8;
  }
  .bajadilla-servicios {
    font-size: 10px;
    font-family: "Source";
    opacity: 0.8;
  }
  .bajadilla-servicios2 {
    font-size: 10px;
    font-family: "Source";
    opacity: 0.8;
  }
  .bajadilla-servicios3 {
    font-size: 10px;
    font-family: "Source";
    opacity: 0.8;
  }
  .mona {
    position: fixed;
    bottom: 55vh;
    right: 35vw;
    height: 5%;
    z-index: 11;
  }
  .foto-alquimistas {
    position: absolute;
    width: 0%;
    bottom: 12vh;
    left: 1vw;
  }
  .row-dani {
    position: relative;
    vertical-align: top;
    top: 1vh;
    width: 70vw;
    max-width: 70vw;
  }
  .foto-dani {
    max-width: 120px;
    top: 0vh;
    right: 3vw;
  }
  .texto-dani1 {
    position: relative;
    left: 3vw;
    font-size: calc(10.5px + 1.21875vw);
    line-height: 1;
    padding-right: 1vw;
    font-style: italic;
    font-weight: 800;
  }
  .texto-dani2 {
    position: relative;
    left: 3vw;
    font-size: calc(7.5px + 1.0875vw);
    font-weight: 300;
    font-style: italic;
    line-height: 1;
  }
  .texto-dani3 {
    position: relative;
    left: 3vw;
    line-height: 1.2;
    font-size: calc(6.5px + 1.01875vw);
    margin-right: 1vw;
  }
  .row-isi {
    position: absolute;
    width: 90vw;
  }
  .foto-isi {
    top: 0vh;
    right: 18vw;
    max-width: 120px;
  }
  .texto-isi1 {
    position: relative;
    right: 23vw;
    padding-top: 0vh;
    line-height: 1;
    font-weight: 800;
    padding-left: 1vw;
    padding-right: 5vw;
    font-size: calc(10.5px + 1.21875vw);
    font-style: italic;
  }
  .texto-isi2 {
    position: relative;
    right: 23vw;
    font-size: calc(7.5px + 1.01875vw);
    font-weight: 300;
    line-height: 1;
    font-style: italic;
    padding-right: 5vw;
  }
  .texto-isi3 {
    position: relative;
    right: 23vw;
    font-size: calc(6.5px + 1.01875vw);
    padding-right: 5vw;
    line-height: 1.2;
  }
}
@media (min-width: 650px) {
  #section5alq .fp-bg {
    background-image: url("../assets/ALQ-FINAL.png");
    background-size: cover;
    background-position-y: 1px;
  }
}
@media (max-width: 650px) {
  #section5alq .fp-bg {
    background-image: url("../assets/ALQ-FINAL960.png");
    background-size: cover;
    background-position-y: 1px;
  }
}
@media (min-width: 640px) and (max-width: 960px) {
  .alq-colab {
    color: #fceae0;
    padding-left: 1vw;
    padding-right: 1vw;
    padding-top: 1vh;
  }
  .circle {
    position: relative;
    top: 0px;
    left: 2px;
    padding-right: 5vw;
    background: #fceae0;
    width: 460px;
    height: 460px;
    -moz-border-radius: 230px;
    -webkit-border-radius: 230px;
    border-radius: 230px;
    z-index: 9999;
  }
  .texto2 {
    font-size: calc(5.5px + 1.01875vw);
    color: #372b5d;
    padding-top: 12vh;
    max-width: 60vw;
    padding-right: 5vw;
    padding-left: 8vw;
  }
}
@media (min-width: 400px) and (max-width: 640px) {
  .alq-colab {
    color: #fceae0;
    padding-left: 1vw;
    padding-right: 1vw;
    padding-top: 1vh;
  }
  .circle {
    position: relative;
    top: 0px;
    left: 2px;
    padding-right: 2vw;
    background: #fceae0;
    width: 340px;
    height: 340px;
    -moz-border-radius: 170px;
    -webkit-border-radius: 170px;
    border-radius: 170px;
    z-index: 9999;
  }
  .texto2 {
    font-size: calc(5.5px + 1.01875vw);
    color: #372b5d;
    padding-top: 12vh;
    max-width: 60vw;
    padding-right: 2vw;
    padding-left: 10vw;
  }
}
@media (max-width: 400px) {
  .alq-colab {
    color: #fceae0;
    padding-left: 1vw;
    padding-right: 1vw;
    padding-top: 1vh;
  }
  .circle {
    position: relative;
    top: 0px;
    left: 2px;
    padding-right: 2vw;
    background: #fceae0;
    width: 250px;
    height: 250px;
    -moz-border-radius: 125px;
    -webkit-border-radius: 125px;
    border-radius: 120px;
    z-index: 9999;
  }
  .texto2 {
    font-size: calc(5.5px + 1.01875vw);
    color: #372b5d;
    padding-top: 6vh;
    max-width: 60vw;
    padding-right: 2vw;
    padding-left: 12vw;
  }
}
</style>
